import { language } from "shared/language";

export const FILE_EXTENSION_CANNOT_DELETE = language.file_extension_cannot_delete;

export const FILE_EXTENSION_CANNOT_UPDATE = language.file_extension_cannot_update;